import config from "../config";
import request, { requestOptions } from "../utils/request";

const baseUrl = `${config.API_ROOT}/app/usage`;

const Usage = {
  async getCredits(params) {
    const { start, end } = params || {};
    const options = await requestOptions("GET", {}, true);
    const url = new URL(`${baseUrl}/credits`);

    if (start) {
      url.searchParams.set("start", start);
    }

    if (end) {
      url.searchParams.set("end", end);
    }

    return request(url, options);
  },
};

export default Usage;
